/* eslint-disable react/no-unknown-property */
import { useLocale } from '@mirai/locale';
import { Progress, Text, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { IFRAME, OFFSET_HEIGHT } from './FormWorldline.constants';
import { L10N } from './FormWorldline.l10n';
import * as style from './FormWorldline.module.css';

export const FormWorldline = ({ response }) => {
  const { translate } = useLocale();

  const [height, setHeight] = useState();
  const [redirectUrl, setRedirectUrl] = useState();

  const iframe = useRef();
  const completed = useRef(false);

  useEffect(() => {
    const serviceOrigin = new URL(process.env.SERVICE_BOOKING).origin;
    const handleMessage = ({ origin, source, data }) => {
      if (completed.current || source !== iframe.current?.contentWindow) return;

      const { height: nextHeight, type, url } = data || {};
      if (Number.isFinite(nextHeight) && nextHeight > 0) return setHeight(`${nextHeight + OFFSET_HEIGHT}px`);
      if (origin !== serviceOrigin || type !== 'mirai:payment-return-frame' || typeof url !== 'string') return;

      let destination;
      try {
        destination = new URL(url);
      } catch {
        return;
      }
      if (
        destination.protocol !== 'https:' ||
        destination.username ||
        destination.password ||
        ![serviceOrigin, window.location.origin].includes(destination.origin)
      )
        return;

      completed.current = true;
      window.removeEventListener('message', handleMessage);
      setRedirectUrl(destination.href);
    };
    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    if (redirectUrl) window.location.href = redirectUrl;
  }, [redirectUrl]);

  return redirectUrl ? (
    <View
      className={style.redirecting}
      role="status"
      aria-label={translate(L10N.LABEL_REDIRECTING)}
      testId="worldline-redirecting"
    >
      <Text>{translate(L10N.LABEL_REDIRECTING)}</Text>
      <Progress indeterminate visible role="progressbar" aria-label={translate(L10N.LABEL_REDIRECTING)} />
    </View>
  ) : (
    <View
      allow="payment"
      id={IFRAME}
      ref={iframe}
      src={response?.configuration?.iframeUrl}
      tag="iframe"
      title={translate(L10N.LABEL_SECURE_PAGE)}
      className={style.iframe}
      {...(height ? { style: { height } } : undefined)}
    />
  );
};

FormWorldline.displayName = 'Mirai:Payments:ButtonPayment:FormWorldline';

FormWorldline.propTypes = {
  response: PropTypes.shape({
    configuration: PropTypes.shape({
      iframeUrl: PropTypes.string,
    }),
  }),
};
